import React from 'react';
import { FormattedMessage } from 'react-intl';
import { NotificationType } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { Truncated } from './components';
import { GenericNotification } from './GenericNotification';

export const purchaseFailedNotification =
  ({ item }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="files-manager.purchased-failed-notification"
            values={{
              itemName: <Truncated>{item.name}</Truncated>,
            }}
          />
        }
        type={NotificationType.Destructive}
      />
    );
